import RoomNo from './RoomNo';

export default RoomNo;
